import "../css/gallery.css";
import { useState, useEffect } from "react";

function ContentGallery({ gallery, id }) {
  const [selectedContent, setSelectedContent] = useState(null);

  // Bloquear el scroll del cuerpo cuando el modal está abierto
  useEffect(() => {
    if (selectedContent !== null) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [selectedContent]);

  return (
    <div className="gallery-wrapper" id={`gallery-${id}`}>
      {/* Rejilla de Imágenes */}
      <div className="gallery-grid">
        {gallery.map((content, index) => (
          <div 
            key={index} 
            className="gallery-card"
            onClick={() => setSelectedContent(content)}
          >
            <div 
              className="thumb-preview"
              dangerouslySetInnerHTML={{ __html: content }} 
            />
          </div>
        ))}
      </div>

      {/* MODAL */}
      {selectedContent && (
        <div className="modal-overlay" onClick={() => setSelectedContent(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-button" onClick={() => setSelectedContent(null)}>
              &times;
            </button>
            <div 
              className="modal-body flex-center  layout8"
              dangerouslySetInnerHTML={{ __html: selectedContent }} 
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default ContentGallery;